// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tour-guide {
  --ink: #15231c;
  --paper: #f3efe4;
  --rule: #c9b89a;
  --accent: #2f6f4e;
  color: var(--ink);
  padding: 8px 4px 48px;
}

.tour-guide__head {
  margin-bottom: 18px;
}

.tour-guide__kicker {
  margin: 0 0 4px;
  font-size: 11px;
  letter-spacing: 0.16em;
  text-transform: uppercase;
  color: var(--accent);
}

.tour-guide__head h1 {
  margin: 0;
  font-size: 28px;
  letter-spacing: -0.03em;
}

.tour-guide__head p {
  margin: 6px 0 0;
  max-width: 42rem;
}

.tour-guide__board {
  display: grid;
  grid-template-columns: minmax(160px, 220px) minmax(220px, 1fr) minmax(280px, 1.1fr);
  gap: 16px;
  align-items: start;
}

.tour-guide__rail,
.tour-guide__sheet,
.tour-guide__form {
  background: var(--paper);
  border: 1px solid var(--rule);
  border-radius: 4px;
}

.tour-guide__rail {
  display: flex;
  flex-direction: column;
  padding: 8px;
  gap: 4px;
}

.tour-guide__book {
  appearance: none;
  text-align: left;
  border: 0;
  background: transparent;
  padding: 10px 8px;
  cursor: pointer;
  border-bottom: 1px dashed var(--rule);
}

.tour-guide__book span {
  display: block;
  font-weight: 650;
}

.tour-guide__book em {
  font-style: normal;
  font-size: 12px;
  opacity: 0.7;
}

.tour-guide__book.is-active {
  background: #e4f0e6;
  box-shadow: inset 3px 0 0 var(--accent);
}

.tour-guide__steps {
  list-style: none;
  margin: 0;
  padding: 8px;
}

.tour-guide__beat {
  width: 100%;
  display: grid;
  grid-template-columns: 36px 1fr;
  grid-template-rows: auto auto;
  column-gap: 8px;
  appearance: none;
  border: 0;
  background: transparent;
  text-align: left;
  padding: 10px 8px;
  cursor: pointer;
  border-bottom: 1px solid rgba(201, 184, 154, 0.6);
}

.tour-guide__beat span {
  grid-row: 1 / span 2;
  font-variant-numeric: tabular-nums;
  font-weight: 700;
  color: var(--accent);
}

.tour-guide__beat.is-active {
  background: #fffdf7;
}

.tour-guide__beat small {
  grid-column: 2;
  opacity: 0.65;
}

.tour-guide__toolbar,
.tour-guide__actions {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  padding: 10px;
}

.tour-guide__form {
  display: grid;
  gap: 10px;
  padding: 14px;
}

.tour-guide__form label {
  display: grid;
  gap: 4px;
  font-size: 12px;
  letter-spacing: 0.04em;
  text-transform: uppercase;
}

.tour-guide__form input,
.tour-guide__form select,
.tour-guide__form textarea {
  font: inherit;
  text-transform: none;
  letter-spacing: 0;
  padding: 8px;
  border: 1px solid var(--rule);
  background: #fffdf7;
}

.tour-guide__check {
  display: flex !important;
  align-items: center;
  gap: 8px;
  text-transform: none;
  letter-spacing: 0;
  font-size: 14px;
}

.tour-guide__actions button,
.tour-guide__toolbar button {
  appearance: none;
  border: 1px solid var(--rule);
  background: #fffdf7;
  padding: 8px 12px;
  cursor: pointer;
}

.tour-guide__actions .is-primary {
  background: var(--accent);
  color: #f7fff9;
  border-color: var(--accent);
}

.tour-guide__status {
  margin: 0 14px 12px;
  font-size: 14px;
}

@media (max-width: 980px) {
  .tour-guide__board {
    grid-template-columns: 1fr;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/superadmin/TourGuideEditor.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,sBAAsB;EACtB,yBAAyB;EACzB,oBAAoB;AACtB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mFAAmF;EACnF,SAAS;EACT,kBAAkB;AACpB;;AAEA;;;EAGE,wBAAwB;EACxB,6BAA6B;EAC7B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,QAAQ;AACV;;AAEA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,SAAS;EACT,uBAAuB;EACvB,iBAAiB;EACjB,eAAe;EACf,qCAAqC;AACvC;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,uCAAuC;AACzC;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,YAAY;AACd;;AAEA;EACE,WAAW;EACX,aAAa;EACb,+BAA+B;EAC/B,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;EAChB,SAAS;EACT,uBAAuB;EACvB,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,iDAAiD;AACnD;;AAEA;EACE,oBAAoB;EACpB,kCAAkC;EAClC,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,aAAa;AACf;;AAEA;;EAEE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,aAAa;AACf;;AAEA;EACE,aAAa;EACb,SAAS;EACT,aAAa;AACf;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,eAAe;EACf,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;;;EAGE,aAAa;EACb,oBAAoB;EACpB,iBAAiB;EACjB,YAAY;EACZ,6BAA6B;EAC7B,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,mBAAmB;EACnB,QAAQ;EACR,oBAAoB;EACpB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;;EAEE,gBAAgB;EAChB,6BAA6B;EAC7B,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF","sourcesContent":[".tour-guide {\n  --ink: #15231c;\n  --paper: #f3efe4;\n  --rule: #c9b89a;\n  --accent: #2f6f4e;\n  color: var(--ink);\n  padding: 8px 4px 48px;\n}\n\n.tour-guide__head {\n  margin-bottom: 18px;\n}\n\n.tour-guide__kicker {\n  margin: 0 0 4px;\n  font-size: 11px;\n  letter-spacing: 0.16em;\n  text-transform: uppercase;\n  color: var(--accent);\n}\n\n.tour-guide__head h1 {\n  margin: 0;\n  font-size: 28px;\n  letter-spacing: -0.03em;\n}\n\n.tour-guide__head p {\n  margin: 6px 0 0;\n  max-width: 42rem;\n}\n\n.tour-guide__board {\n  display: grid;\n  grid-template-columns: minmax(160px, 220px) minmax(220px, 1fr) minmax(280px, 1.1fr);\n  gap: 16px;\n  align-items: start;\n}\n\n.tour-guide__rail,\n.tour-guide__sheet,\n.tour-guide__form {\n  background: var(--paper);\n  border: 1px solid var(--rule);\n  border-radius: 4px;\n}\n\n.tour-guide__rail {\n  display: flex;\n  flex-direction: column;\n  padding: 8px;\n  gap: 4px;\n}\n\n.tour-guide__book {\n  appearance: none;\n  text-align: left;\n  border: 0;\n  background: transparent;\n  padding: 10px 8px;\n  cursor: pointer;\n  border-bottom: 1px dashed var(--rule);\n}\n\n.tour-guide__book span {\n  display: block;\n  font-weight: 650;\n}\n\n.tour-guide__book em {\n  font-style: normal;\n  font-size: 12px;\n  opacity: 0.7;\n}\n\n.tour-guide__book.is-active {\n  background: #e4f0e6;\n  box-shadow: inset 3px 0 0 var(--accent);\n}\n\n.tour-guide__steps {\n  list-style: none;\n  margin: 0;\n  padding: 8px;\n}\n\n.tour-guide__beat {\n  width: 100%;\n  display: grid;\n  grid-template-columns: 36px 1fr;\n  grid-template-rows: auto auto;\n  column-gap: 8px;\n  appearance: none;\n  border: 0;\n  background: transparent;\n  text-align: left;\n  padding: 10px 8px;\n  cursor: pointer;\n  border-bottom: 1px solid rgba(201, 184, 154, 0.6);\n}\n\n.tour-guide__beat span {\n  grid-row: 1 / span 2;\n  font-variant-numeric: tabular-nums;\n  font-weight: 700;\n  color: var(--accent);\n}\n\n.tour-guide__beat.is-active {\n  background: #fffdf7;\n}\n\n.tour-guide__beat small {\n  grid-column: 2;\n  opacity: 0.65;\n}\n\n.tour-guide__toolbar,\n.tour-guide__actions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  padding: 10px;\n}\n\n.tour-guide__form {\n  display: grid;\n  gap: 10px;\n  padding: 14px;\n}\n\n.tour-guide__form label {\n  display: grid;\n  gap: 4px;\n  font-size: 12px;\n  letter-spacing: 0.04em;\n  text-transform: uppercase;\n}\n\n.tour-guide__form input,\n.tour-guide__form select,\n.tour-guide__form textarea {\n  font: inherit;\n  text-transform: none;\n  letter-spacing: 0;\n  padding: 8px;\n  border: 1px solid var(--rule);\n  background: #fffdf7;\n}\n\n.tour-guide__check {\n  display: flex !important;\n  align-items: center;\n  gap: 8px;\n  text-transform: none;\n  letter-spacing: 0;\n  font-size: 14px;\n}\n\n.tour-guide__actions button,\n.tour-guide__toolbar button {\n  appearance: none;\n  border: 1px solid var(--rule);\n  background: #fffdf7;\n  padding: 8px 12px;\n  cursor: pointer;\n}\n\n.tour-guide__actions .is-primary {\n  background: var(--accent);\n  color: #f7fff9;\n  border-color: var(--accent);\n}\n\n.tour-guide__status {\n  margin: 0 14px 12px;\n  font-size: 14px;\n}\n\n@media (max-width: 980px) {\n  .tour-guide__board {\n    grid-template-columns: 1fr;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
